import { SETTINGS_SET_ACTION, TSettingsActions } from "../actions/settingsSetAction";
import { ISettings } from "../../components/Sessings/Settings";
import { DEFAULT_SORT_ORDER } from "../../components/Sort/Sort";

export const initialState: ISettings = {
    sortOrder: DEFAULT_SORT_ORDER,
    filterSets: {
        approvedDividends: false,
        applicabilityStrategy: false,
    }
};

export const settingsReducer = (state: ISettings = initialState, action: TSettingsActions): ISettings => {
    switch (action.type) {
        case SETTINGS_SET_ACTION:
            return { ...state, ...action.settings };

        default:
            return state;
    }
}; 